import { render, staticRenderFns } from "./Instrument.vue?vue&type=template&id=152199b4&"
import script from "./Instrument.vue?vue&type=script&lang=js&"
export * from "./Instrument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports